module.exports = __webpack_public_path__ + "img/personal-account.c4ef758.jpg";